import { useMemo } from 'react';
import {
  addHours,
  isAfter,
  isBefore,
  isSameDay,
  parseISO,
  startOfDay,
} from 'date-fns';
import { Order } from '../../../core/types/order';
import { useCalendar } from '../../../core/redux/calendar';
import { nextWorkingDay } from '../../../core/calendar';

type OrderData = Pick<Order, 'id' | 'createdTimestamp' | 'date'>;

export const useIsLate = () => {
  const { data: calendar } = useCalendar();
  const isLate = useMemo(
    () => (order: OrderData) => {
      if (order === undefined) return false;
      const createdTimestamp = parseISO(order.createdTimestamp);
      const orderDate = parseISO(order.date);
      const limit = addHours(startOfDay(createdTimestamp), 12);
      const nextwd = nextWorkingDay(createdTimestamp, calendar || []);
      return (
        isSameDay(createdTimestamp, orderDate)
        || (isAfter(createdTimestamp, limit) && isBefore(orderDate, nextwd))
      );
    },
    [calendar],
  );

  return { isLate };
};

export const useIsOrderLate = (order: OrderData | undefined) => {
  const { isLate: isLateFunc } = useIsLate();
  const isLate = useMemo(() => {
    if (order === undefined) return false;
    return isLateFunc(order);
  }, [order, isLateFunc]);

  return { isLate };
};
